import colors from "../base/colors";
import borders from "../base/borders";
import typography from "../base/typography";

import pxToRem from "../functions/pxToRem";

const { info, success, warning, error } = colors;
const { borderRadius } = borders;
const { size } = typography;

const alertContentInherit = {
  "& .MuiAlert-message": { color: "inherit" },
  "& .MuiAlertTitle-root": { color: "inherit", fontWeight: 600 },
  "& .MuiTypography-root": { color: "inherit" },
  "& .MuiIconButton-root": { color: "inherit" },
};

const filledVariant = (palette: { main: string; contrastText: string }) => ({
  backgroundColor: palette.main,
  color: palette.contrastText,
  "& .MuiAlert-icon": { color: palette.contrastText },
  ...alertContentInherit,
});

const standardVariant = (backgroundColor: string, textColor: string, iconColor: string) => ({
  backgroundColor,
  color: textColor,
  "& .MuiAlert-icon": { color: iconColor },
  ...alertContentInherit,
});

const outlinedVariant = (borderColor: string, textColor: string, iconColor: string) => ({
  borderColor,
  color: textColor,
  "& .MuiAlert-icon": { color: iconColor },
  ...alertContentInherit,
});

const alert = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      padding: `${pxToRem(10)} ${pxToRem(14)}`,
    },
    message: {
      fontSize: size.sm,
      lineHeight: 1.5,
      color: "inherit",
    },
    standardInfo: standardVariant("rgba(56, 189, 248, 0.14)", info.light, info.main),
    standardSuccess: standardVariant("rgba(52, 211, 153, 0.14)", success.light, success.main),
    standardWarning: standardVariant("rgba(251, 191, 36, 0.14)", warning.light, warning.main),
    standardError: standardVariant("rgba(248, 113, 113, 0.14)", error.light, error.main),
    outlinedInfo: outlinedVariant(info.main, info.light, info.main),
    outlinedSuccess: outlinedVariant(success.main, success.light, success.main),
    outlinedWarning: outlinedVariant(warning.main, warning.light, warning.main),
    outlinedError: outlinedVariant(error.main, error.light, error.main),
    filledInfo: filledVariant(info),
    filledSuccess: filledVariant(success),
    filledWarning: filledVariant(warning),
    filledError: filledVariant(error),
  },
};

export default alert;
